export default "__VITE_ASSET__BlpHBK68__"